import { createProxyIdentifier } from '../../services/extensions/common/proxyIdentifier.js';
var TextEditorRevealType;
( (function(TextEditorRevealType) {
    TextEditorRevealType[TextEditorRevealType["Default"] = 0] = "Default";
    TextEditorRevealType[TextEditorRevealType["InCenter"] = 1] = "InCenter";
    TextEditorRevealType[TextEditorRevealType["InCenterIfOutsideViewport"] = 2] = "InCenterIfOutsideViewport";
    TextEditorRevealType[TextEditorRevealType["AtTop"] = 3] = "AtTop";
})(TextEditorRevealType || (TextEditorRevealType = {})));
var NotebookEditorRevealType;
( (function(NotebookEditorRevealType) {
    NotebookEditorRevealType[NotebookEditorRevealType["Default"] = 0] = "Default";
    NotebookEditorRevealType[NotebookEditorRevealType["InCenter"] = 1] = "InCenter";
    NotebookEditorRevealType[NotebookEditorRevealType["InCenterIfOutsideViewport"] = 2] = "InCenterIfOutsideViewport";
    NotebookEditorRevealType[NotebookEditorRevealType["AtTop"] = 3] = "AtTop";
})(NotebookEditorRevealType || (NotebookEditorRevealType = {})));
var CandidatePortSource;
( (function(CandidatePortSource) {
    CandidatePortSource[CandidatePortSource["None"] = 0] = "None";
    CandidatePortSource[CandidatePortSource["Process"] = 1] = "Process";
    CandidatePortSource[CandidatePortSource["Output"] = 2] = "Output";
})(CandidatePortSource || (CandidatePortSource = {})));
class IdObject {
    static { this._n = 0; }
    static mixin(object) {
        object._id = IdObject._n++;
        return object;
    }
}
const MainContext = {
    MainThreadAuthentication: ( createProxyIdentifier('MainThreadAuthentication')),
    MainThreadBulkEdits: ( createProxyIdentifier('MainThreadBulkEdits')),
    MainThreadChatProvider: ( createProxyIdentifier('MainThreadChatProvider')),
    MainThreadChatAgents2: ( createProxyIdentifier('MainThreadChatAgents2')),
    MainThreadChatVariables: ( createProxyIdentifier('MainThreadChatVariables')),
    MainThreadClipboard: ( createProxyIdentifier('MainThreadClipboard')),
    MainThreadCommands: ( createProxyIdentifier('MainThreadCommands')),
    MainThreadComments: ( createProxyIdentifier('MainThreadComments')),
    MainThreadConfiguration: ( createProxyIdentifier('MainThreadConfiguration')),
    MainThreadConsole: ( createProxyIdentifier('MainThreadConsole')),
    MainThreadDebugService: ( createProxyIdentifier('MainThreadDebugService')),
    MainThreadDecorations: ( createProxyIdentifier('MainThreadDecorations')),
    MainThreadDiagnostics: ( createProxyIdentifier('MainThreadDiagnostics')),
    MainThreadDialogs: ( createProxyIdentifier('MainThreadDiaglogs')),
    MainThreadDocuments: ( createProxyIdentifier('MainThreadDocuments')),
    MainThreadDocumentContentProviders: ( createProxyIdentifier('MainThreadDocumentContentProviders')),
    MainThreadTextEditors: ( createProxyIdentifier('MainThreadTextEditors')),
    MainThreadEditorInsets: ( createProxyIdentifier('MainThreadEditorInsets')),
    MainThreadEditorTabs: ( createProxyIdentifier('MainThreadEditorTabs')),
    MainThreadErrors: ( createProxyIdentifier('MainThreadErrors')),
    MainThreadTreeViews: ( createProxyIdentifier('MainThreadTreeViews')),
    MainThreadDownloadService: ( createProxyIdentifier('MainThreadDownloadService')),
    MainThreadLanguageFeatures: ( createProxyIdentifier('MainThreadLanguageFeatures')),
    MainThreadLanguages: ( createProxyIdentifier('MainThreadLanguages')),
    MainThreadLogger: ( createProxyIdentifier('MainThreadLogger')),
    MainThreadMessageService: ( createProxyIdentifier('MainThreadMessageService')),
    MainThreadOutputService: ( createProxyIdentifier('MainThreadOutputService')),
    MainThreadProgress: ( createProxyIdentifier('MainThreadProgress')),
    MainThreadQuickDiff: ( createProxyIdentifier('MainThreadQuickDiff')),
    MainThreadQuickOpen: ( createProxyIdentifier('MainThreadQuickOpen')),
    MainThreadStatusBar: ( createProxyIdentifier('MainThreadStatusBar')),
    MainThreadSecretState: ( createProxyIdentifier('MainThreadSecretState')),
    MainThreadStorage: ( createProxyIdentifier('MainThreadStorage')),
    MainThreadSpeech: ( createProxyIdentifier('MainThreadSpeechProvider')),
    MainThreadTelemetry: ( createProxyIdentifier('MainThreadTelemetry')),
    MainThreadTerminalService: ( createProxyIdentifier('MainThreadTerminalService')),
    MainThreadWebviews: ( createProxyIdentifier('MainThreadWebviews')),
    MainThreadWebviewPanels: ( createProxyIdentifier('MainThreadWebviewPanels')),
    MainThreadWebviewViews: ( createProxyIdentifier('MainThreadWebviewViews')),
    MainThreadCustomEditors: ( createProxyIdentifier('MainThreadCustomEditors')),
    MainThreadUrls: ( createProxyIdentifier('MainThreadUrls')),
    MainThreadUriOpeners: ( createProxyIdentifier('MainThreadUriOpeners')),
    MainThreadProfileContentHandlers: ( createProxyIdentifier('MainThreadProfileContentHandlers')),
    MainThreadWorkspace: ( createProxyIdentifier('MainThreadWorkspace')),
    MainThreadFileSystem: ( createProxyIdentifier('MainThreadFileSystem')),
    MainThreadFileSystemEventService: ( createProxyIdentifier('MainThreadFileSystemEventService')),
    MainThreadExtensionService: ( createProxyIdentifier('MainThreadExtensionService')),
    MainThreadSCM: ( createProxyIdentifier('MainThreadSCM')),
    MainThreadSearch: ( createProxyIdentifier('MainThreadSearch')),
    MainThreadShare: ( createProxyIdentifier('MainThreadShare')),
    MainThreadTask: ( createProxyIdentifier('MainThreadTask')),
    MainThreadWindow: ( createProxyIdentifier('MainThreadWindow')),
    MainThreadLabelService: ( createProxyIdentifier('MainThreadLabelService')),
    MainThreadNotebook: ( createProxyIdentifier('MainThreadNotebook')),
    MainThreadNotebookDocuments: ( createProxyIdentifier('MainThreadNotebookDocumentsShape')),
    MainThreadNotebookEditors: ( createProxyIdentifier('MainThreadNotebookEditorsShape')),
    MainThreadNotebookKernels: ( createProxyIdentifier('MainThreadNotebookKernels')),
    MainThreadNotebookRenderers: ( createProxyIdentifier('MainThreadNotebookRenderers')),
    MainThreadInteractive: ( createProxyIdentifier('MainThreadInteractive')),
    MainThreadChat: ( createProxyIdentifier('MainThreadChat')),
    MainThreadInlineChat: ( createProxyIdentifier('MainThreadInlineChatShape')),
    MainThreadTheming: ( createProxyIdentifier('MainThreadTheming')),
    MainThreadTunnelService: ( createProxyIdentifier('MainThreadTunnelService')),
    MainThreadManagedSockets: ( createProxyIdentifier('MainThreadManagedSockets')),
    MainThreadTimeline: ( createProxyIdentifier('MainThreadTimeline')),
    MainThreadTesting: ( createProxyIdentifier('MainThreadTesting')),
    MainThreadLocalization: ( createProxyIdentifier('MainThreadLocalizationShape')),
    MainThreadAiRelatedInformation: ( createProxyIdentifier('MainThreadAiRelatedInformation')),
    MainThreadAiEmbeddingVector: ( createProxyIdentifier('MainThreadAiEmbeddingVector')),
    MainThreadIssueReporter: ( createProxyIdentifier('MainThreadIssueReporter')),
};
const ExtHostContext = {
    ExtHostCommands: ( createProxyIdentifier('ExtHostCommands')),
    ExtHostConfiguration: ( createProxyIdentifier('ExtHostConfiguration')),
    ExtHostDiagnostics: ( createProxyIdentifier('ExtHostDiagnostics')),
    ExtHostDebugService: ( createProxyIdentifier('ExtHostDebugService')),
    ExtHostDecorations: ( createProxyIdentifier('ExtHostDecorations')),
    ExtHostDocumentsAndEditors: ( createProxyIdentifier('ExtHostDocumentsAndEditors')),
    ExtHostDocuments: ( createProxyIdentifier('ExtHostDocuments')),
    ExtHostDocumentContentProviders: ( createProxyIdentifier('ExtHostDocumentContentProviders')),
    ExtHostDocumentSaveParticipant: ( createProxyIdentifier('ExtHostDocumentSaveParticipant')),
    ExtHostEditors: ( createProxyIdentifier('ExtHostEditors')),
    ExtHostTreeViews: ( createProxyIdentifier('ExtHostTreeViews')),
    ExtHostFileSystem: ( createProxyIdentifier('ExtHostFileSystem')),
    ExtHostFileSystemInfo: ( createProxyIdentifier('ExtHostFileSystemInfo')),
    ExtHostFileSystemEventService: ( createProxyIdentifier('ExtHostFileSystemEventService')),
    ExtHostLanguages: ( createProxyIdentifier('ExtHostLanguages')),
    ExtHostLanguageFeatures: ( createProxyIdentifier('ExtHostLanguageFeatures')),
    ExtHostQuickOpen: ( createProxyIdentifier('ExtHostQuickOpen')),
    ExtHostQuickDiff: ( createProxyIdentifier('ExtHostQuickDiff')),
    ExtHostStatusBar: ( createProxyIdentifier('ExtHostStatusBar')),
    ExtHostShare: ( createProxyIdentifier('ExtHostShare')),
    ExtHostExtensionService: ( createProxyIdentifier('ExtHostExtensionService')),
    ExtHostLogLevelServiceShape: ( createProxyIdentifier('ExtHostLogLevelServiceShape')),
    ExtHostTerminalService: ( createProxyIdentifier('ExtHostTerminalService')),
    ExtHostSCM: ( createProxyIdentifier('ExtHostSCM')),
    ExtHostSearch: ( createProxyIdentifier('ExtHostSearch')),
    ExtHostTask: ( createProxyIdentifier('ExtHostTask')),
    ExtHostWorkspace: ( createProxyIdentifier('ExtHostWorkspace')),
    ExtHostWindow: ( createProxyIdentifier('ExtHostWindow')),
    ExtHostWebviews: ( createProxyIdentifier('ExtHostWebviews')),
    ExtHostWebviewPanels: ( createProxyIdentifier('ExtHostWebviewPanels')),
    ExtHostCustomEditors: ( createProxyIdentifier('ExtHostCustomEditors')),
    ExtHostWebviewViews: ( createProxyIdentifier('ExtHostWebviewViews')),
    ExtHostEditorInsets: ( createProxyIdentifier('ExtHostEditorInsets')),
    ExtHostEditorTabs: ( createProxyIdentifier('ExtHostEditorTabs')),
    ExtHostProgress: ( createProxyIdentifier('ExtHostProgress')),
    ExtHostComments: ( createProxyIdentifier('ExtHostComments')),
    ExtHostSecretState: ( createProxyIdentifier('ExtHostSecretState')),
    ExtHostStorage: ( createProxyIdentifier('ExtHostStorage')),
    ExtHostUrls: ( createProxyIdentifier('ExtHostUrls')),
    ExtHostUriOpeners: ( createProxyIdentifier('ExtHostUriOpeners')),
    ExtHostProfileContentHandlers: ( createProxyIdentifier('ExtHostProfileContentHandlers')),
    ExtHostOutputService: ( createProxyIdentifier('ExtHostOutputService')),
    ExtHosLabelService: ( createProxyIdentifier('ExtHostLabelService')),
    ExtHostNotebook: ( createProxyIdentifier('ExtHostNotebook')),
    ExtHostNotebookDocuments: ( createProxyIdentifier('ExtHostNotebookDocuments')),
    ExtHostNotebookEditors: ( createProxyIdentifier('ExtHostNotebookEditors')),
    ExtHostNotebookKernels: ( createProxyIdentifier('ExtHostNotebookKernels')),
    ExtHostNotebookRenderers: ( createProxyIdentifier('ExtHostNotebookRenderers')),
    ExtHostNotebookDocumentSaveParticipant: ( createProxyIdentifier('ExtHostNotebookDocumentSaveParticipant')),
    ExtHostInteractive: ( createProxyIdentifier('ExtHostInteractive')),
    ExtHostInlineChat: ( createProxyIdentifier('ExtHostInlineChatShape')),
    ExtHostChat: ( createProxyIdentifier('ExtHostChat')),
    ExtHostChatAgents2: ( createProxyIdentifier('ExtHostChatAgents')),
    ExtHostChatVariables: ( createProxyIdentifier('ExtHostChatVariables')),
    ExtHostChatProvider: ( createProxyIdentifier('ExtHostChatProvider')),
    ExtHostSpeech: ( createProxyIdentifier('ExtHostSpeech')),
    ExtHostAiRelatedInformation: ( createProxyIdentifier('ExtHostAiRelatedInformation')),
    ExtHostAiEmbeddingVector: ( createProxyIdentifier('ExtHostAiEmbeddingVector')),
    ExtHostTheming: ( createProxyIdentifier('ExtHostTheming')),
    ExtHostTunnelService: ( createProxyIdentifier('ExtHostTunnelService')),
    ExtHostManagedSockets: ( createProxyIdentifier('ExtHostManagedSockets')),
    ExtHostAuthentication: ( createProxyIdentifier('ExtHostAuthentication')),
    ExtHostTimeline: ( createProxyIdentifier('ExtHostTimeline')),
    ExtHostTesting: ( createProxyIdentifier('ExtHostTesting')),
    ExtHostTelemetry: ( createProxyIdentifier('ExtHostTelemetry')),
    ExtHostLocalization: ( createProxyIdentifier('ExtHostLocalization')),
    ExtHostIssueReporter: ( createProxyIdentifier('ExtHostIssueReporter')),
};
export { CandidatePortSource, ExtHostContext, IdObject, MainContext, NotebookEditorRevealType, TextEditorRevealType };
